/*
 * @Author: yzr
 * @Date: 2020-11-24 09:37:03
 * @LastEditors: yzr
 * @LastEditTime: 2020-11-27 15:13:36
 */
import Target from './target.vue';

export default Target;
